/**
 * VILD House of Little JavaScript
 * Author: OneSizeUp [www.onesizeup.com]
 *
 */

$(window).load(function() {
  
  // HOMEPAGE FADE IN EFFECT
  if($('body').hasClass('template-index')) {
    $('.slide img').each(function() {
      $(this).fadeIn(1000);
    });
    $('.slide a').each(function() {
      $(this).fadeTo( 1400 , 1);
    });
  }
  
  // Add currency selector text onload
  $('.locale-selectors__content').prepend('<p>Choose a currency</p>')
  
});

$(document).ready(function() {
  
  /* ****************************************************************** */
    /* !FUNCTIONS */
  /* ****************************************************************** */ 
  
  // If product added to cart, let people know yo
  function osuOverlay(text, modalclass) {
    var $this = $('.modal');
    $('.modal--text').text(text);    
    $this.removeClass().addClass('modal');
    $this.addClass(modalclass);
    $this.fadeIn(500, function() {
      $this.delay(1000).fadeOut();
    });
  }
  
  function osuOverlayNew(text, modalclass) {
    var $this = $('.cart--modified');
    $this.removeClass().addClass('cart--modified');
    $this.addClass(modalclass);
    $('.cart--modified_text').text(text);
    $this.fadeIn(500, function() {
      $this.delay(1000).fadeOut();
    });
  }
  
  // Check for mobile (not perfect, but a good technique using Modernizr)
  // Source: http://stackoverflow.com/a/17326467/621098
  var deviceAgent = navigator.userAgent.toLowerCase();
  var isTouchDevice = Modernizr.touch || 
      (deviceAgent.match(/(iphone|ipod|ipad)/) ||
       deviceAgent.match(/(android)/)  || 
       deviceAgent.match(/(iemobile)/) || 
       deviceAgent.match(/iphone/i) || 
       deviceAgent.match(/ipad/i) || 
       deviceAgent.match(/ipod/i) || 
       deviceAgent.match(/blackberry/i) || 
       deviceAgent.match(/webos/) || 
       deviceAgent.match(/bada/i)
      );
  // Usage:
  /*
  if (isTouchDevice) {
    //Do something touchy
  } else {
    //Can't touch this
  }
  */
  
  // Cache scrolling events
  var didScroll = false;
  $(window).scroll(function() {
    didScroll = true;
  });
  /* Usage:
  setInterval(function() {
    if (didScroll) {
      didScroll = false; // reset didScroll to prevent multiple $(window).scroll(...); calls
        // Execute code
	  }
	}, 250);

  */
  
  // Cache resizing events
  var didResize = (function(){
    var timer = 0;
    return function(callback, ms){
      clearTimeout (timer);
      timer = setTimeout(callback, ms);
    };
  })();
  /* Usage:
  $(window).resize(function() {
    didResize(function(){
      // Execute code
    }, 500);
  });
  */
  
  
  /* ****************************************************************** */
    /* !NAV */
  /* ****************************************************************** */ 

  // New top sections nav

  // Add .active class to parent if child has .active class
  $('.top-sections-header').has('.active').addClass('active');
  
  // show dropdown on click/tap for touch devices
  $('.primarynav .top-sections li a').on('click', function() {
    $('.primarynav .top-sections ul').hide();
    if ($(this).next('ul').length) {
      $(this).next('ul').slideToggle();
      return false;
    }
  });

  // hide dropdown on resize
  $(window).on('resize', function() {
    if ($(window).width() > 767) {
      $('.top-sections ul').removeAttr('style');
    }
  });

  // Show .dropdown within .slide-out-nav if li.active present in child
  if($('.slide-out-nav .dropdown').find('li.active').length !== 0) {
    $('.slide-out-nav li.active > .dropdown').show();
  }
  
  // Toggle slide out nav
  $('.nav-toggle').click(function() {
    $(this).toggleClass('active');
    $('.slide-out-nav').addClass('slideout');
  });
  
  $('.slideout-close').click(function() {
    $('.nav-toggle').toggleClass('active');
    $('.slide-out-nav').removeClass('slideout');
  });
  
  /* ****************************************************************** */
    /* !HOMEPAGE */
  /* ****************************************************************** */ 
  
  if($('body').hasClass('template-index') || $('body').hasClass('template-page-about')) {
    
    $('.slides').slick({
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      dots: true
    });
    
    $('.grid-block').on('click', function() {
      var goTo = $(this).find('a').attr('href');
      window.location.href = goTo;
    });
    
    /*
    var l = $('.slides-container').find('a').attr('href');
    $('.slide').on('click', function() {
      window.location.href = l;
    });
    */
    
  }
  
  
  /* ****************************************************************** */
    /* !COLLECTION */
  /* ****************************************************************** */ 
  
  // Hoverswap function
  var hoverSwap = function () {
    var $this       = $(this).find('img');
    var li 	      	= $(this);
    var overlay     = $(this).find('.product-overlay');
    //var newSource     = $this.data('hover-src');
    //$this.data('hover-src', $this.attr('src')); // Show original source if hover-src is showing
    //$this.attr('src', newSource); // Vice versa
    
    // Correct classes depending on hover state
    if( overlay.hasClass('hover') ) {
      overlay.removeClass('hover');
    } else {
      overlay.addClass('hover');
    }
    if( li.hasClass('img-opaque') ) {
      li.removeClass('img-opaque');
    } else {
      li.addClass('img-opaque'); // Make images opaque on hover so can see overlay on dark images
    }
    
  }
  
  if($('body').hasClass('template-collection') || $('body').hasClass('template-search') || $('body').hasClass('template-page-list-collection')) {
    
    // Check if touchscreen / mobile
    if (!isTouchDevice) {
      $('.product-listing li').hoverIntent({
        over: hoverSwap,
        out: hoverSwap,
        interval: 10
      });
    } else {
      $('.product-listing').addClass('touchy'); // add class to show overlay on touch devices
    }
    
    // Clicking on overlay takes you through to product
    $('.product-overlay').click(function() {
      window.location = $(this).find("a:first").attr("href");
      return false;
    });
    $(".product-overlay span a").click(function (e) {
      e.stopPropagation(); // Allow container social links to be clicked independently
    });
    
    // Preload images so that hover function works asap
    var preloadImgs = [];
    $(".product-listing img").each(function() {
      var img = new Image();
      img.src = $(this).data("hover-src");
      preloadImgs.push(img);
    });
    
  }

  // Read more / less link for collection descriptions
  $('.read-more-collection-desc').on('click', function() {
    var $desc = $('.collection-desc');
    $desc.toggleClass('expanded');
    $(this).text($desc.hasClass('expanded') ? 'Show less' : 'Show more');
  });
  
  
  /* ****************************************************************** */
    /* !SEARCH */
  /* ****************************************************************** */ 
  
  if($('body').hasClass('template-search')) {
    $('.search-form--togglebtn').click(function() {
      $('.search-form--toggle').slideToggle('fast');
    });
  }
  
  
  /* ****************************************************************** */
    /* !SINGLE PRODUCT */
  /* ****************************************************************** */ 

  if($('body').hasClass('template-product')) {
    
    // Slick Carousel
    var imagesNav = $('.images-nav');
    $(".slick-carousel").slick({
      dots : false,
      arrows: true,
      adaptiveHeight : true,
      prevArrow: '<a href="javascript:void(0);" class="pr">&lt;</a>',
          nextArrow: '<a href="javascript:void(0);" class="nx">&gt;</a>',
          appendArrows: imagesNav,
      autoplay: false
    });
    
    // Related images Slick Carousel
    var imagesNavRelated = $('.images-nav-related');
    $(".slick-carousel-related").slick({
      infinite: true,
      dots : true,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight : true,
      prevArrow: '<a href="javascript:void(0);" class="pr">&lt;</a>',
          nextArrow: '<a href="javascript:void(0);" class="nx">&gt;</a>',
          appendArrows: imagesNavRelated,
      autoplay: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
    
    // Product image zoom    
    $(".jq-zoom").each(function(arg, el){
      var image = $(el).find("img");
      $(el).zoom({
        on: 'mouseover',
        url: image.parent().attr('data-highres'),
        magnify: 1.5
      });
    });
    
    // Remove Product Loader animation after pageload
    $(window).on('load', function() {
      $('.product-loader').fadeOut();
    });
    
    // Changing product quantities etc.
    $('select').on('change', function() {
      var labelText = $(this).find("option:selected").text();
      $(this).prev().text(labelText);
      
    });
    $('#productSelect').on('change', function() {
      var actualPrice 		= $(this).find("option:selected").data('price');
      var comparePrice 		= $(this).find("option:selected").data('compare');
      var productCurrency	= $(this).find("option:selected").data('currency');
      $('.actual-price').text(actualPrice);
      $('.compare-price').text(comparePrice);
      $('.product-currency').text(productCurrency);
    });   
    
    // Washing instructions
    $('.washing-instructions--toggle').click(function() {
      $(this).next().slideToggle('medium');
    });
    
    // SINGLE PRODUCT AJAX CALLS
    // -------------------------------------------------------------------- //
    
    // Create event handler to keep cart count updated, no matter success/failure.
    $(document).on('cart.requestComplete', function(event, cart) {
      $('#cartCount').html(cart.item_count);
    });
     
    // Create event handler for successful addition.
    $(document).ajaxSuccess(function(event, jqxhr, settings) {
      if(settings.url == "/cart/add.js") {
        osuOverlayNew('Item added to your bag!', 'cart--modified_success');
        $('.go-to-cart').fadeIn('medium');
      }
    });
     
    // Create event handler for failed addition.
    $(document).ajaxError(function(event, jqxhr, settings, thrownError) {
      if(settings.url == "/cart/add.js") {
        var items_left = $('#productSelect option:selected').data('inventory');
        osuOverlayNew('Sorry, there is only a total of ' + items_left + ' of these in stock!', 'cart--modified_error');
      }
    });
     
    // Create event listener for form submission.
    $('#addToCartForm').submit(function() {
      /*
      var size = $('#productSelect option:selected').val();
      var qty = $('#quantity option:selected').val();
      
      if(size == 'choose size') {
        alert('Please make sure you\'ve chosen a size and quantity for this product');
        return false;
      }
      */
    });
    
  }
  
  
  /* ****************************************************************** */
    /* !CART */
  /* ****************************************************************** */
  
  if($('body').hasClass('template-cart')) {
    
    // T&C's
    $(".checkout").click(function() {
      if($('#agree').is(':checked')) {
        $(".checkout").submit();
      } else {
        alert("Please agree to the Terms and Conditions");
        return false;
      }
    });
    
    // Show gift box
    $('.cart-row--gift input').click(function() {
      $('.cart-row--note').slideToggle('medium');
    });
    
    // Limit characters
    var maxLength = 70;
    $('#gift-message').keyup(function() {
      var textlen = maxLength - $(this).val().length;
      $('.chars-left span').text(textlen);
    });
    
    
    // CART.JS & RIVET.JS AJAX CALLS
    // -------------------------------------------------------------------- //
    
    // NOTE :
    // Removing &pound; from prices is done using a Rivet Formatter just before the CartJS.init
    
    // If no more items left when changing quantities in the cart, alert user
    var cartItemCount;

    // Store number of items before adjusting cart.
    $(document).on('cart.requestStarted', function(event, cart) {
      cartItemCount = cart.item_count;
    });
    
    // Check items in cart after adding new item
    $(document).on('cart.requestComplete', function(event, cart) {
        if(cartItemCount == cart.item_count) {
            osuOverlay('Sorry, there are no more of these in stock,', 'modal--error');
        }
    });
    
    // Clear cart
    $('.clear-cart').click(function() {
      if (confirm('Are you sure you want to clear your cart?')) {
        CartJS.clear();
        var msg = '<p><a href="/collections/all">Continue browsing here</a>.</p>';
        $('.main-heading').text('Nothing in your bag').after(msg);
        $('.cart-row').each(function() {
          $(this).fadeOut('medium');
          
        });
      }
    });
    
  };
  
  /* ****************************************************************** */
	/* !COOKIES & MODALS */
  /* ****************************************************************** */ 

  // Cookie / ppolicy consent
  var cookie = $.cookie('_accept_cookies');
  $('.cc-off').click(function() {
	$.cookie('_accept_cookies', 'yes', { expires: 14, path: '/' }); // expires in 14 days, valid throughout site
    $('.cc').fadeOut(500);
  });
  if(cookie == 'yes') {
    // Privacy Policy / Cookies accepted
  } else {
    $('.cc').delay(100).fadeIn('slow');
  }
  // $.removeCookie('_accept_cookies', { path: '/' });
  
  // Newsletter modal overlay for homepage
  var nccookie = $.cookie('_newsletter');
  if($('body').hasClass('template-index') || $('body').hasClass('template-page-newsletter')) {
    
    $('.nc').click(function() {
      $.cookie('_newsletter', 'yes', { expires: 14, path: '/' }); // expires in 14 days, valid throughout site
      $('.modal-newsletter').fadeToggle(500);
    });
    
    if(nccookie == 'yes') {
      // Keep newsletter modal hidden
    } else {
      setTimeout(function() {
        $('.modal-newsletter').fadeToggle(500);
      }, 3000);
    }
    
  } else {
    
    $('.nc').click(function() {
      $.cookie('_newsletter', 'yes', { expires: 14, path: '/' }); // expires in 14 days, valid throughout site
      $('.modal-newsletter').fadeToggle(500);
    });
    
  }
  //$.removeCookie('_newsletter', { path: '/' });
  
  // Newsletter form modal
  $('.newsletter-box').click(function() {
    $('.modal-newsletter').fadeToggle(500);
  });
  
  // Size guide modal
  $('.sizeguide--toggle, .modal-sizeguide a').click(function() {
    $('.modal-sizeguide').fadeToggle(500);
  });  
  
  
  /* ****************************************************************** */
    /* !GENERAL */
  /* ****************************************************************** */ 
  
  // IE fallback for 
  if (!Modernizr.svg) {
    // $(".logo img").attr("src", "logo.png");
    var ms_src 	= $(".logo img").attr("src");
    $(ms_src).replace(".svg",".png");
  }
  
});